import React, { useContext, useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDSelectBox from "components/MDSelectBox";
import ImageUploader from "components/MDImageUploader";
import { useFormik } from "formik";
import MDDatePicker from "components/MDDatepicker";
import FormControl from "@mui/material/FormControl";
import { Grid, Radio } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MetrimonialContext } from "context/MetrimonialContext";
import { ModalContext } from "context/ModalContext";
import { addMatrimonialApi } from "Apis/matrimonialApi";
import moment from "moment";
import PropTypes from "prop-types";
import { updateMatrimonialDataApi } from "Apis/matrimonialApi";
import { LoginFormContext } from "context/LoginFormContext";
import MDDropzone from "components/MDDropzone";
import { initialValues } from "./schemas/initialValue";
import { ValidationSchema } from "./schemas/validation";
import { MemberContext } from "context/MemberContext";
import SingleCheckbox from "components/MDCheckBox/MDSingleCheckBox";
import { statusData } from "helpers/constant";
import SubmitButton from "components/SubmitButton";

const MetrimonialForm = ({ getmatrimonialAllData }) => {
  const { setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const { editData, maritalStatusData, jsonListing } = useContext(MetrimonialContext);
  const { setNotification, profileImage, setProfileImage } = useContext(LoginFormContext);
  const { parentMemberList } = useContext(MemberContext);
  const [maritalStatus, setMaritalStatus] = useState({});
  const [marriedStatus, setMarriedStatus] = useState("");
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const [member, setMember] = useState(null);
  const [isVerified, setIsVerified] = useState(0);

  const handleSubmit = async (value) => {
    if (!formIsEdit) {
      let response = await addMatrimonialApi(value);
      if (response?.status === 200) {
        setDocument(null);
        setOpen(false);
        setFormIsEdit(false);
        setMaritalStatus("");
        getmatrimonialAllData();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      let editresponse = await updateMatrimonialDataApi(value);
      if (editresponse?.status === 200) {
        setDocument(null);
        setOpen(false);
        setMaritalStatus("");
        getmatrimonialAllData();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: editresponse.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: editresponse.data.message,
          open: true,
        });
      }
    }
  };

  const setDataInFormik = async () => {
    formik.setValues(editData);
    setIsVerified(editData?.is_verified);
    if (editData.matrimonial_documents) {
      const documentItem = editData.matrimonial_documents.find((item) => item.type === "Document");
      if (documentItem) {
        const file = new File([], documentItem.image.split("/").slice(-1)[0]);
        setDocument([file]);
      }

      formik.setFieldValue(
        "matrimonial_document",
        editData?.matrimonial_documents
          .find((item) => item.type === "Document")
          ?.image?.split("/")
          ?.slice(-1)[0]
      );
      formik.setFieldValue(
        "matrimonial_image",
        editData?.matrimonial_documents
          .find((item) => item.type === "Image")
          ?.image?.split("/")
          ?.slice(-1)[0]
      );
    }
    setProfileImage({
      url: editData?.matrimonial_documents
        ? editData?.matrimonial_documents.find((item) => item.type === "Image")?.image
        : null,
      name: null,
    });
  };

  const getMaritalLabel = (val) => {
    const materialStatus = maritalStatusData.find((item) => item?.label == val);
    return materialStatus ? materialStatus.label : "-";
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const hasMarriedStatus = (value) => {
    if (value) {
      formik.setFieldValue("marital_status", value.label);
      setMarriedStatus(value);
    } else {
      formik.setFieldValue("marital_status", null);
      setMarriedStatus(null);
    }
  };

  const getMemberLabel = (id) => {
    const member = parentMemberList.find((item) => item.value === id);
    return member ? member.label : "-";
  };

  useEffect(() => {
    jsonListing();
    if (formIsEdit) {
      setDataInFormik();
      setMarriedStatus({
        label: getMaritalLabel(editData?.marital_status),
      });
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
      setMember(
        editData.member_id
          ? { label: getMemberLabel(editData.member_id), value: editData.member_id }
          : null
      );
    } else if (formIsEdit === false) {
      setProfileImage({
        url: null,
        name: null,
      });
    }
  }, []);

  const handleDate = (date, fieldName) => {
    if (date) {
      let dateFormat = moment(new Date(date)).format("MM-DD-YYYY");
      formik.setFieldValue("birth_date", dateFormat);
    } else {
      formik.setFieldValue(fieldName, null);
    }
  };

  const handleAutocompleteChange = (value, name) => {
    const str_value = value ? value.label : "";
    formik.setFieldValue(name, str_value);
    setMaritalStatus((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [document, setDocument] = useState([]);
  const onFileChange = (e) => {
    if (e.length > 0) {
      setDocument(e);
      formik.setFieldValue("matrimonial_document", e[0]?.path);
    } else {
      setDocument([]);
      formik.setFieldValue("matrimonial_document", null);
    }
  };

  const formik = useFormik({
    initialValues: formIsEdit ? editData : initialValues,
    validationSchema: ValidationSchema,
    onSubmit: handleSubmit,
  });

  const handleMember = async (data) => {
    formik.setFieldValue("member_id", data?.value);
    setMember(data?.label);
  };

  const handleIsVerified = (e) => {
    setIsVerified(e?.target?.checked);
    formik.setFieldValue("is_verified", e?.target?.checked ? 1 : 0);
  };

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        {/* Image */}
        <MDBox
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            marginBottom: "5px",
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Profile Image
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </MDBox>
        <MDBox mb={2} className="metromonial_image">
          <MDBox className="metromonial_message">
            <ImageUploader
              img={profileImage.url}
              folderName={"/matrimonials"}
              name={"matrimonial_image"}
              fileName={"matrimonial_image"}
              formik={formik}
              label="Profile Image"
              hideLabel={true}
              required={true}
            />
            {formik.touched.matrimonial_image && formik.errors.matrimonial_image && (
              <MDBox
                component="p"
                sx={{
                  fontSize: "12px",
                  marginLeft: "20px",
                  color: "red",
                  marginTop: "5px",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  whiteSpace: "nowrap",
                }}
              >
                {formik.errors.matrimonial_image}
              </MDBox>
            )}
          </MDBox>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ "@media (max-width: 768px)": { paddingTop: "5px !important" } }}
          >
            <MDBox
              sx={{
                fontSize: "14px",
                width: "100%",
                paddingLeft: "20px",
                paddingTop: "15px",
                "@media (max-width: 768px)": {
                  display: "block",
                  paddingLeft: "0px",
                },
              }}
            >
              Image can't be larger than 5 MB
              <span
                style={{
                  marginTop: "2px",
                  display: "block",
                }}
              >
                (છબીનું કદ 5 mb કરતાં ઓછું હોવું જરૂરી છે)
              </span>
            </MDBox>
          </Grid>
        </MDBox>

        <MDBox sx={{ marginTop: "10px" }}>
          <MDInput
            type="text"
            name="full_name"
            label="Full Name (પૂરું નામ)"
            variant="standard"
            value={formik.values.full_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            fullWidth
            required
          />
          {formik.touched.full_name && formik.errors.full_name && (
            <MDBox
              component="p"
              sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
            >
              {formik.errors.full_name}
            </MDBox>
          )}
        </MDBox>

        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: "41px !important" }}>
            <MDBox className="date__picker">
              <MDDatePicker
                width="100% !important"
                name="birth_date"
                label="Birth Date (જન્મ તારીખ)"
                value={formik.values.birth_date}
                onChange={(date) => handleDate(date, "birth_date")}
                onBlur={formik.handleBlur}
                required
              />
              {formik.touched.birth_date && formik.errors.birth_date && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.birth_date}
                </MDBox>
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <MDBox>
              <MDSelectBox
                name="marital_status"
                defaultValue={marriedStatus}
                options={maritalStatusData}
                handleChange={(value) => hasMarriedStatus(value)}
                label="Marital Status"
                multiple={false}
                width="100%"
                onBlur={formik.handleBlur}
                required
              />
              {formik.touched.marital_status && formik.errors.marital_status && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.marital_status}
                </MDBox>
              )}
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDBox
              sx={{ fontSize: "16px", fontWeight: "400", marginBottom: "5px", marginTop: "10px" }}
            >
              Gender (જાતિ) <span style={{ color: "red" }}>*</span>
            </MDBox>
            <FormControl>
              <RadioGroup
                row
                sx={{ gap: "20px" }}
                name="gender"
                value={formik.values.gender}
                onBlur={formik.handleBlur}
                onChange={(event) => formik.setFieldValue("gender", event.target.value)}
              >
                <FormControlLabel value="Male" control={<Radio />} label="Male" />
                <FormControlLabel value="Female" control={<Radio />} label="Female" />
              </RadioGroup>
              {formik.touched.gender && formik.errors.gender && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.gender}
                </MDBox>
              )}
            </FormControl>
          </Grid>
        </Grid>

        {/* status */}
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="member_id"
              defaultValue={member}
              options={parentMemberList}
              handleChange={(value) => handleMember(value)}
              label="Head Member"
              width="100%"
              isImage={true}
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.member_id && formik.errors.member_id && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.member_id}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
          <SingleCheckbox
            xs={12}
            sm={12}
            md={12}
            name="is_verified"
            label={
              <>
                This Matrimonial is verified
                <br />
                <span style={{ marginTop: "8px", display: "block" }}>
                  (આ મેટ્રિમોનિયલ પ્રોફાઈલ વેરીફાઈ થયેલ છે)
                </span>
              </>
            }
            onChange={(event) => handleIsVerified(event)}
            onBlur={formik.handleBlur}
            checked={isVerified}
          />
        </Grid>

        <>
          <MDBox
            sx={{ fontSize: "16px", fontWeight: "400", marginBottom: "5px", marginTop: "20px" }}
          >
            Upload Bio Data <span style={{ color: "red" }}>*</span>
          </MDBox>
          <MDBox mb={2}>
            <MDDropzone
              value={document ?? []}
              name={"matrimonial_document"}
              fileName="matrimonial_document"
              formik={formik}
              folderName={"/documents"}
              // onChange={(e) => onFileChange(e)}
              maxFileSize={10}
              accept=".pdf, .doc, .docx, .img, .jpg, .jpeg, .png, .rtf"
              onBlur={formik.handleBlur}
              multiple={false}
            />
            {formik.touched.matrimonial_document && formik.errors.matrimonial_document && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.matrimonial_document}
              </MDBox>
            )}
          </MDBox>
        </>

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </>
  );
};
MetrimonialForm.propTypes = {
  getmatrimonialAllData: PropTypes.func.isRequired,
};

export default MetrimonialForm;
